import React from 'react'
import FacebookLogo from '../../../svgs/FacebookLogo'
import BombardierLogo from '../../../svgs/BombardierLogo'
import SaintGobainLogo from '../../../svgs/SaintGobainLogo'
import UniversalRobotsLogo from '../../../svgs/UniversalRobotsLogo'
import SiemensLogo from '../../../svgs/SiemensLogo'
import StrykerLogo from '../../../svgs/StrykerLogo'
import CreaformLogo from '../../../svgs/CreaformLogo'
import BmwLogo from '../../../svgs/BmwLogo'

interface Props {
  readonly tag?: string
  readonly title?: string
}

const DocsLogos: React.FunctionComponent<Props> = ({ tag, title }) => {
  const Tag = `${tag}` as 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
  return (
    <div className='docs-logos'>
      <div className='docs-logos-container'>
        {title && <Tag>{title}</Tag>}
        <ul className='docs-logos-list'>
          <li className='docs-logos-list-item bmw-logo'>
            <BmwLogo width='60%' height='40%' />
          </li>
          <li className='docs-logos-list-item creaform-logo'>
            <CreaformLogo width='100%' height='100%' />
          </li>
          <li className='docs-logos-list-item facebook-logo'>
            <FacebookLogo width='100%' height='100%' />
          </li>
          <li className='docs-logos-list-item stryker-logo'>
            <StrykerLogo width='100%' height='100%' />
          </li>
          <li className='docs-logos-list-item siemens-logo'>
            <SiemensLogo width='100%' height='100%' />
          </li>
          <li className='docs-logos-list-item bombardier-logo'>
            <BombardierLogo width='100%' height='100%' />
          </li>
          <li className='docs-logos-list-item universalrobots-logo'>
            <UniversalRobotsLogo width='100%' height='100%' />
          </li>
          <li className='docs-logos-list-item saintgobain-logo'>
            <SaintGobainLogo width='100%' height='100%' />
          </li>
        </ul>
      </div>
    </div>
  )
}

export default DocsLogos
